var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsufficientbalance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4345_1394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 73.0001C48.6913 73.0001 62.2223 59.4692 62.2223 42.7779C62.2223 26.0866 48.6913 12.5557 32.0001 12.5557C15.3088 12.5557 1.77783 26.0866 1.77783 42.7779C1.77783 59.4692 15.3088 73.0001 32.0001 73.0001Z",
    fill: "#F4900C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 69.4444C48.6913 69.4444 62.2223 55.9135 62.2223 39.2222C62.2223 22.5309 48.6913 9 32.0001 9C15.3088 9 1.77783 22.5309 1.77783 39.2222C1.77783 55.9135 15.3088 69.4444 32.0001 69.4444Z",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 65.8891C45.7457 65.8891 56.8889 54.746 56.8889 41.0002C56.8889 27.2545 45.7457 16.1113 32 16.1113C18.2542 16.1113 7.11108 27.2545 7.11108 41.0002C7.11108 54.746 18.2542 65.8891 32 65.8891Z",
    fill: "#FFE8B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 64.1113C45.7457 64.1113 56.8889 52.9681 56.8889 39.2224C56.8889 25.4766 45.7457 14.3335 32 14.3335C18.2542 14.3335 7.11108 25.4766 7.11108 39.2224C7.11108 52.9681 18.2542 64.1113 32 64.1113Z",
    fill: "#FFAC33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7393 24.0966C34.6316 23.0265 36.3694 23.7578 36.2283 25.1441L35.2316 34.8825H43.2941C43.5624 34.8826 43.8251 34.9591 44.0514 35.1031C44.2777 35.2471 44.4584 35.4526 44.5721 35.6955C44.6859 35.9384 44.7281 36.2088 44.6938 36.4748C44.6595 36.7409 44.5501 36.9916 44.3784 37.1978L30.2607 54.1389C29.3685 55.209 27.6306 54.4778 27.7718 53.0914L28.7685 43.3531H20.7059C20.4377 43.353 20.175 43.2764 19.9486 43.1324C19.7223 42.9884 19.5417 42.7829 19.4279 42.54C19.3142 42.2971 19.272 42.0267 19.3063 41.7607C19.3406 41.4946 19.45 41.2439 19.6217 41.0378L33.7393 24.0966Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4345_1394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57 1.25C58.8944 1.25 60.6861 1.61085 62.3672 2.33594C64.0337 3.05476 65.4894 4.03343 66.7275 5.27246C67.9654 6.51119 68.9445 7.96658 69.665 9.63184C70.3922 11.3127 70.7527 13.1052 70.75 15.001C70.7473 16.8954 70.3872 18.6864 69.665 20.3662C68.9486 22.0327 67.9695 23.4893 66.7275 24.7285C65.4865 25.9668 64.0309 26.9453 62.3682 27.665C60.6899 28.3914 58.8977 28.7508 57 28.749V28.75C55.104 28.75 53.3124 28.3893 51.6328 27.6641C49.9679 26.9452 48.5122 25.9663 47.2725 24.7275C46.0327 23.4886 45.0539 22.033 44.3359 20.3672C43.6118 18.687 43.2509 16.895 43.25 15C43.2491 13.1048 43.6099 11.3132 44.3359 9.63281C45.0556 7.96739 46.0336 6.51129 47.2715 5.27246C48.5097 4.03334 49.9662 3.0548 51.6328 2.33594C53.3139 1.61085 55.1056 1.25 57 1.25ZM56.998 14.4502C56.8219 14.4498 56.7078 14.5009 56.6055 14.6035C56.5016 14.7077 56.4502 14.8237 56.4502 15V20.2002C56.4502 20.3791 56.5023 20.4945 56.6045 20.5967C56.7066 20.6988 56.8211 20.7504 56.998 20.75H57C57.1789 20.75 57.2943 20.6978 57.3965 20.5957C57.4986 20.4936 57.5501 20.379 57.5498 20.2021V15C57.5498 14.821 57.4979 14.7065 57.3965 14.6055C57.2936 14.5029 57.1771 14.4506 56.998 14.4502ZM57 9.25C56.8211 9.25 56.7065 9.30201 56.6055 9.40332C56.5029 9.50623 56.4506 9.62271 56.4502 9.80176C56.4498 9.9779 56.5011 10.0928 56.6045 10.1963C56.7079 10.2997 56.822 10.3504 56.9961 10.3496H57C57.179 10.3496 57.2942 10.2975 57.3965 10.1953C57.4987 10.0931 57.5502 9.97884 57.5498 9.80176C57.5494 9.62271 57.4971 9.50623 57.3945 9.40332C57.2935 9.30201 57.1789 9.25 57 9.25Z",
    fill: "#E84141",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4345_1394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 9)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4345_1394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(42)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsufficientbalance);
export default __webpack_public_path__ + "static/media/insufficientbalance.9e7867f0d4b6932b6a5336a4409bd781.svg";
export { ForwardRef as ReactComponent };